import * as React from 'react';

function DropDownIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} width={16} height={16} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.0876 4.83785C3.31541 4.61004 3.68475 4.61004 3.91256 4.83785L7.00008 7.92537L10.0876 4.83785C10.3154 4.61004 10.6848 4.61004 10.9126 4.83785C11.1404 5.06565 11.1404 5.435 10.9126 5.6628L7.41256 9.1628C7.18475 9.39061 6.81541 9.39061 6.5876 9.1628L3.0876 5.6628C2.8598 5.435 2.8598 5.06565 3.0876 4.83785Z"
        fill="#737F8F"
      />
    </svg>
  );
}

const MemoDropDownIcon = React.memo(DropDownIcon);
export default MemoDropDownIcon;
